// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WechatOutlinedSvg from "@ant-design/icons-svg/es/asn/WechatOutlined";
import AntdIcon from '../components/AntdIcon';

var WechatOutlined = function WechatOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WechatOutlinedSvg
  }));
};

WechatOutlined.displayName = 'WechatOutlined';
export default React.forwardRef(WechatOutlined);